import React from 'react';

import { FormControl, Input } from '@mui/material';

import { TRADE_IN_VALUE } from '../../constants/LoansCalculator/AutoLoans';

import './TradeInValueInput.css';

export const TradeInValueInput = ({ tradeInValue, onTradeInValueChange }) => {
  return (
    <div className="loans-financing-field-wrapper">
      <p className="trade-in-value-label">{TRADE_IN_VALUE}</p>
      <FormControl
        sx={{
          width: '100%',
        }}
      >
        <Input
          id="trade-in-value-financing-select-helper"
          value={tradeInValue || ''}
          placeholder={TRADE_IN_VALUE}
          autoComplete="off"
          onChange={(e) => {
            if (!isNaN(e.target.value)) {
              onTradeInValueChange(e.target.value);
            } else {
              onTradeInValueChange('');
            }
          }}
          disableUnderline
        />
      </FormControl>
    </div>
  );
};
